export enum TransactionType {
  'Transfer Into Game Provider' = 1,
  'Transfer Out to Main Wallet'
}